import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/cssbuy-spreadsheet-guide-2026/page";
import KakobuyComparison from "@/pages/article/kakobuy-vs-cssbuy-comparison/page";
import SuperbuyGuide from "@/pages/article/superbuy-spreadsheet-premium-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/best-cssbuy-spreadsheet-guide-2026",
    element: <ArticleGuide />,
  },
  {
    path: "/article/kakobuy-vs-cssbuy-spreadsheet-comparison",
    element: <KakobuyComparison />,
  },
  {
    path: "/article/superbuy-spreadsheet-premium-guide",
    element: <SuperbuyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;